import React from 'react';
import { buildCreditActionHint, creditBadgeLabel, creditCostForNav } from '@/constants/ipeCredits';
import useModuleCreditsRevision from '@/hooks/useModuleCreditsRevision';

/**
 * 展示单次操作将消耗的 IPE豆（进入模块不扣费，确认/保存/提交时扣费）
 */
export default function IpeCreditCostHint({
  navId,
  imageCount = 1,
  variant = 'inline',
  className = '',
}) {
  const moduleCreditsRevision = useModuleCreditsRevision();
  void moduleCreditsRevision;
  const cost = creditCostForNav(navId);
  const text = buildCreditActionHint(navId, imageCount);
  const badge = creditBadgeLabel(navId);
  if (!cost || !text) return null;

  if (variant === 'badge') {
    return (
      <span className={`ipe-credit-cost-hint ipe-credit-cost-hint--badge ${className}`.trim()} title={text}>
        {badge || `${cost}IPE豆`}
      </span>
    );
  }

  return (
    <p className={`ipe-credit-cost-hint ipe-credit-cost-hint--inline ${className}`.trim()} role="note">
      {text}
    </p>
  );
}
